/* Herbonise — custom sections behaviour (theme-agnostic: works in Horizon or Dawn) */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var WISHLIST_KEY = 'herbonise:wishlist';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  /* ---------------- Header ---------------- */
  function initHeader(header) {
    if (!header || header.dataset.hbReady) return;
    header.dataset.hbReady = '1';

    // Sticky header. Works whichever element scrolls: the window (Dawn) or an inner
    // wrapper such as Horizon's .page-wrapper. The section wrapper keeps the header's
    // height in the flow, and its position decides when the header becomes fixed.
    if (header.hasAttribute('data-hb-sticky')) {
      var holder = header.parentElement;
      var ticking = false;
      var measure = function () {
        if (header.classList.contains('is-fixed')) return;
        holder.style.minHeight = header.offsetHeight + 'px';
        document.documentElement.style.setProperty('--hb-header-height', header.offsetHeight + 'px');
      };
      var update = function () {
        ticking = false;
        var fixed = holder.getBoundingClientRect().top < 0;
        if (fixed !== header.classList.contains('is-fixed')) header.classList.toggle('is-fixed', fixed);
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      };
      measure();
      window.addEventListener('resize', function () { header.classList.remove('is-fixed'); measure(); update(); }, { passive: true });
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      update();
    }

    // Drawer
    var drawer = $('[data-hb-drawer]', header);
    var openBtn = $('[data-hb-drawer-open]', header);
    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      var pw = document.querySelector('.page-wrapper');
      if (pw && getComputedStyle(pw).overflowY !== 'visible') pw.style.overflow = open ? 'hidden' : '';
      if (open) { var c = $('[data-hb-drawer-close].hb-icon-btn', drawer); c && c.focus(); }
      else if (openBtn) openBtn.focus();
    }
    openBtn && openBtn.addEventListener('click', function () { setDrawer(true); });
    $$('[data-hb-drawer-close]', header).forEach(function (el) { el.addEventListener('click', function () { setDrawer(false); }); });

    // Search
    var search = $('[data-hb-search]', header);
    var searchBtn = $('[data-hb-search-open]', header);
    var input = $('[data-hb-search-input]', header);
    var results = $('[data-hb-search-results]', header);
    function setSearch(open) {
      if (!search) return;
      search.classList.toggle('is-open', open);
      search.setAttribute('aria-hidden', open ? 'false' : 'true');
      searchBtn && searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) setTimeout(function () { input && input.focus(); }, 60);
    }
    searchBtn && searchBtn.addEventListener('click', function () { setSearch(!search.classList.contains('is-open')); });
    $$('[data-hb-search-close]', header).forEach(function (el) { el.addEventListener('click', function () { setSearch(false); searchBtn && searchBtn.focus(); }); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer && drawer.classList.contains('is-open')) setDrawer(false);
      if (search && search.classList.contains('is-open')) { setSearch(false); searchBtn && searchBtn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (search && search.classList.contains('is-open') && !search.contains(e.target) && !(searchBtn && searchBtn.contains(e.target))) setSearch(false);
    });

    // Predictive search
    var timer, controller;
    input && input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () { predict(q); }, 220);
    });
    function predict(q) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          var all = root + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last';
          if (!items.length) {
            results.innerHTML = '<p class="hb-search__empty">No products found for “' + esc(q) + '”.</p>';
            return;
          }
          var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
          var html = '<div class="hb-search__grid">' + items.map(function (p) {
            var img = p.image ? '<img class="hb-search__thumb" src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="58" height="58">' : '<span class="hb-search__thumb"></span>';
            var price = p.price ? '<span class="hb-search__price">' + esc(formatPrice(p.price, cur)) + '</span>' : '';
            return '<a class="hb-search__hit" href="' + esc(p.url) + '">' + img + '<span><span class="hb-search__name">' + esc(p.title) + '</span>' + price + '</span></a>';
          }).join('') + '</div><a class="hb-search__all" href="' + esc(all) + '">View all results</a>';
          results.innerHTML = html;
        })
        .catch(function () {});
    }
    function formatPrice(v, cur) {
      var n = parseFloat(v);
      if (isNaN(n)) return v;
      try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur || 'PKR', maximumFractionDigits: n % 1 ? 2 : 0 }).format(n); }
      catch (e) { return (cur ? cur + ' ' : '') + n.toFixed(2); }
    }

    // Cart icon: open the theme's cart drawer when there is one (Horizon / Dawn), else go to /cart
    $$('.hb-cart', header).forEach(function (link) {
      link.addEventListener('click', function (e) {
        var drawer = findCartDrawer();
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          try { drawer.open(link); } catch (err) { window.location.href = link.href; }
        }
      });
    });

    // Country / currency selector
    $$('[data-hb-locale-select]', header).forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form && sel.form.submit(); });
    });
  }

  /* ---------------- Hero slider ---------------- */
  function initSlider(el) {
    if (!el || el.dataset.hbReady) return;
    el.dataset.hbReady = '1';
    var slides = $$('[data-hb-slide]', el);
    var dots = $$('[data-hb-dot]', el);
    if (slides.length < 2) return;
    var index = 0, timer = null;
    var autoplay = el.dataset.autoplay === 'true';
    var speed = parseInt(el.dataset.speed, 10) || 6000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a, button', s).forEach(function (a) { on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1'); });
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); d.setAttribute('aria-selected', n === index ? 'true' : 'false'); });
    }
    function play() { stop(); if (autoplay && !reduce) timer = setInterval(function () { go(index + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.hbDot, 10)); play(); }); });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', play);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', play);

    // swipe
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null; play();
    }, { passive: true });

    // theme editor: show the selected slide
    el.addEventListener('shopify:block:select', function (e) {
      var s = e.target.closest('[data-hb-slide]');
      if (s) { stop(); go(parseInt(s.dataset.index, 10)); }
    });
    el.addEventListener('shopify:block:deselect', play);

    play();
  }

  /* ---------------- Cart drawer + add to cart (shared by product page & quickshop) ---------------- */
  function findCartDrawer() {
    // Horizon: <theme-drawer id="cart-drawer">  ·  Dawn: <cart-drawer>
    return document.querySelector('theme-drawer#cart-drawer') || document.querySelector('cart-drawer');
  }
  function addToCart(items, opts) {
    opts = opts || {};
    var drawer = findCartDrawer();
    var isHorizon = drawer && drawer.tagName === 'THEME-DRAWER';
    var isDawn = drawer && drawer.tagName === 'CART-DRAWER' && typeof drawer.renderContents === 'function';
    var body = { items: items };
    if (isHorizon) { body.sections = 'cart-drawer-section'; body.sections_url = window.location.pathname; }
    if (isDawn) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    return nativeFetchRef(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { var err = new Error(res.json && (res.json.description || res.json.message) || 'Could not add to cart'); err.data = res.json; throw err; }
        var opened = false;
        try {
          if (isHorizon && res.json.sections && res.json.sections['cart-drawer-section']) {
            var doc = new DOMParser().parseFromString(res.json.sections['cart-drawer-section'], 'text/html');
            var fresh = doc.querySelector('.cart-drawer__inner');
            var current = drawer.querySelector('.cart-drawer__inner');
            if (fresh && current) current.replaceWith(fresh);
          }
          if (isDawn) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.json);
            opened = true;
          }
        } catch (e) {}
        refreshCart();
        document.dispatchEvent(new CustomEvent('herbonise:cart-added', { detail: { items: items, response: res.json } }));
        if (opts.openDrawer !== false && drawer && !opened && typeof drawer.open === 'function') {
          try { drawer.open(); opened = true; } catch (e) {}
        }
        return { item: res.json, drawerOpened: opened };
      });
  }

  /* ---------------- Cart count (listens to any theme's add-to-cart) ---------------- */
  function setCartCount(n) {
    // v2: badge shows the number only (was: '(' + n + ')')
    $$('[data-hb-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('aria-label', n + ' items in cart'); });
  }
  function refreshCart() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }
  var nativeFetch = window.fetch;
  function nativeFetchRef() { return nativeFetch.apply(window, arguments); }
  if (window.fetch && !window.fetch.__hbWrapped) {
    var wrapped = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (r) { if (r.ok) setTimeout(refreshCart, 50); }).catch(function () {});
      }
      return p;
    };
    wrapped.__hbWrapped = true;
    window.fetch = wrapped;
  }
  document.addEventListener('cart:update', refreshCart);           // Horizon
  document.addEventListener('cart:refresh', refreshCart);
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) { // Dawn
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCart); } catch (e) {}
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---------------- Wishlist count ----------------
     Reads localStorage "herbonise:wishlist" (array of product handles).
     Any wishlist app/button can write there, or call window.Herbonise.wishlist.toggle(handle). */
  function readWishlist() {
    try { var v = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function renderWishlist() {
    var n = readWishlist().length;
    $$('[data-hb-wishlist-count]').forEach(function (el) { el.textContent = n; });
  }
  window.Herbonise = window.Herbonise || {};
  window.Herbonise.addToCart = addToCart;
  window.Herbonise.openCart = function () { var d = findCartDrawer(); if (d && typeof d.open === 'function') { d.open(); return true; } return false; };
  window.Herbonise.wishlist = {
    get: readWishlist,
    has: function (h) { return readWishlist().indexOf(h) > -1; },
    toggle: function (h) {
      var list = readWishlist(), i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
      renderWishlist();
      document.dispatchEvent(new CustomEvent('herbonise:wishlist', { detail: { items: list } }));
      return i === -1;
    }
  };
  window.addEventListener('storage', function (e) { if (e.key === WISHLIST_KEY) renderWishlist(); });

  /* ---------------- Boot ---------------- */
  function init(ctx) {
    $$('[data-hb-header]', ctx).forEach(initHeader);
    $$('[data-hb-slider]', ctx).forEach(initSlider);
    renderWishlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
